import { useMeterType } from 'hooks/useMeterType';
import { useHasInitialState } from 'components/direct-sales/personalise-quote/hooks/useHasInitialState';

export const useMeterExceptions = () => {
  const { selectedFuelErrors, meterTypeErrors } = useMeterType();
  const hasInitialState = useHasInitialState();
  // in case of fuel selection (ie: meter validation) handle only selected fuel errors
  // otherwise handle all meter errors
  const errors = hasInitialState.fuel ? meterTypeErrors : selectedFuelErrors;

  return {
    errors,
    hasMeterExceptions: !!errors?.length
  };
};
